/** Inactivity timeout before a session is expired (default: 10 minutes). */
export const SESSION_TIMEOUT_MS = 10 * 60 * 1000;

export const SESSION_ACTIVITY_CHECK_MS = 30 * 1000;
